module.exports = __webpack_public_path__ + "img/periodo11.c5d58449.svg";